import { useCallback, useEffect } from 'react';

import { Store } from '@reduxjs/toolkit';

import { authActions } from 'store/slices/auth';

import RedirectManager from './RedirectManager';

export function callRedirect(store: Store): void {
  const ref = RedirectManager.getDefault();

  if (ref) {
    ref.redirect(store);
  }
}

const Redirect: React.FC = () => {
  const redirect = useCallback((store: Store) => {
    store.dispatch(authActions.logoutRequest());
  }, []);

  useEffect(() => {
    RedirectManager.register({ redirect });
  }, [redirect]);

  return <></>;
};

export default Redirect;
